import React, { useMemo, useState } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { Icon } from '../../../../components/Component';
import { LinkList } from '../../../../components/links/Links';
import UserAvatar from '../../../../components/user/UserAvatar';
import { clearLocalStorage, getFromLocalStorage } from '../../../../utils/storage';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../../context/auth.context';

function getInitials(name) {
  if (!name) return ''; // Si el nombre es undefined o null, devuelve una cadena vacía.

  const words = name.trim().split(' '); // Divide el nombre en palabras.
  const initials = words
    .slice(0, 2) // Toma las primeras dos palabras (si existen).
    .map(word => word[0].toUpperCase()) // Toma la primera letra y la convierte a mayúscula.
    .join(''); // Une las letras en una cadena.

  return initials;
}

const User = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(prevState => !prevState);
  const navigation = useNavigate();
  const user = useMemo(() => {
    return getFromLocalStorage('user');
  }, []);

  const { logout } = useAuth();

  // Antes solo se borraba el almacenamiento: el contexto seguía creyendo que
  // había sesión y con «atrás» se volvía a un panel sin token.
  const closeSession = (evento) => {
    evento?.preventDefault();
    clearLocalStorage();
    logout();
    navigation(`${process.env.PUBLIC_URL}/login`);
  };

  return (
    <Dropdown isOpen={open} className='user-dropdown' toggle={toggle}>
      <DropdownToggle
        tag='a'
        href='#toggle'
        className='dropdown-toggle'
        onClick={ev => {
          ev.preventDefault();
        }}
      >
        <div className='user-toggle'>
          <UserAvatar icon='user-alt' className='sm' />
        </div>
      </DropdownToggle>
      <DropdownMenu end className='dropdown-menu-md'>
        <div className='dropdown-inner user-card-wrap bg-lighter d-none d-md-block'>
          <div className='user-card sm'>
            <div className='user-avatar'>
              <span>{getInitials(user?.name)}</span>
            </div>
            <div className='user-info'>
              <span className='lead-text'>{user?.name}</span>
              <span className='sub-text'>{user?.email}</span>
            </div>
          </div>
        </div>
        {/* <div className="dropdown-inner">
          <LinkList>
            <LinkItem link="/user-profile-regular" icon="user-alt" onClick={toggle}>
              View Profile
            </LinkItem>
            <LinkItem link="/user-profile-setting" icon="setting-alt" onClick={toggle}>
              Account Setting
            </LinkItem>
            <LinkItem link="/user-profile-activity" icon="activity-alt" onClick={toggle}>
              Login Activity
            </LinkItem>
            <li>
              <a className={`dark-switch ${theme.skin === 'dark' ? 'active' : ''}`} href="#" 
              onClick={(ev) => {
                ev.preventDefault();
                themeUpdate.skin(theme.skin === 'dark' ? 'light' : 'dark');
              }}>
                {theme.skin === 'dark' ? 
                  <><em className="icon ni ni-sun"></em><span>Light Mode</span></> 
                  : 
                  <><em className="icon ni ni-moon"></em><span>Dark Mode</span></>
                }
              </a>
            </li>
          </LinkList>
        </div> */}
        <div className='dropdown-inner'>
          <LinkList>
            <a href='#' onClick={closeSession}>
              <Icon name='signout'></Icon>
              <span>Cerrar sesión</span>
            </a>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;
